/* BSW Produktkarte – Größe + Farbe wählen, CTA verlinkt direkt auf die Variante
   Logik (Stand 20.10.26):
   - Größe steht oben; eine Größe gilt als verfügbar, sobald es sie in IRGENDEINER Farbe gibt
   - Größe gewählt, die es in der aktuellen Farbe nicht gibt -> Farbe springt auf eine verfügbare (Bild wechselt mit)
   - Farben, die es in der gewählten Größe nicht gibt, werden durchgestrichen (bleiben klickbar)
   - Größen-Chips werden sortiert (XS -> XXL bzw. aufsteigend in cm) */
(function () {
  if (customElements.get('bsw-card-picker')) return;

  var LETTER = { XXS: 1, XS: 2, S: 3, SM: 3, M: 4, MD: 4, L: 5, LG: 5, XL: 6, XXL: 7, XXXL: 8 };
  function sizeKey(s) {
    var t = String(s || '').toUpperCase().trim();
    var m = t.match(/^S(\d)\b/);
    if (m) return [2, +m[1], 0];
    m = t.match(/^(XXXL|XXL|XL|XXS|XS|SM|S|MD|M|LG|L)(?![A-Z])\s*[-\/]?\s*(\d+)?/);
    if (m) return [1, LETTER[m[1]], m[2] ? parseFloat(m[2]) : 0];
    m = t.match(/(\d+(?:[.,]\d+)?)/);
    if (m) return [3, parseFloat(m[1].replace(',', '.')), 0];
    return [9, 0, 0];
  }
  function compareSizes(a, b) {
    var ka = sizeKey(a), kb = sizeKey(b);
    for (var i = 0; i < 3; i++) if (ka[i] !== kb[i]) return ka[i] - kb[i];
    return 0;
  }
  window.bswCompareSizes = window.bswCompareSizes || compareSizes;

  class BswCardPicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      const data = this.querySelector('script[data-variants]');
      try {
        this.variants = JSON.parse(data ? data.textContent : '[]');
      } catch (e) {
        this.variants = [];
      }
      this.ci = parseInt(this.dataset.colorIndex, 10);
      this.si = parseInt(this.dataset.sizeIndex, 10);
      this.color = this.dataset.defaultColor || null;
      this.size = null;
      this.touched = false;

      this.cta = this.querySelector('[data-cta]');
      this.ctaSel = this.querySelector('[data-cta-sel]');
      this.colorLabel = this.querySelector('[data-color-label]');
      this.baseHref = this.cta ? this.cta.getAttribute('href') : null;

      const card = this.closest('.bsw-card');
      this.img = card ? card.querySelector('.bsw-card__img') : null;
      if (this.img) {
        this.imgOrig = {
          src: this.img.getAttribute('src'),
          srcset: this.img.getAttribute('srcset'),
        };
      }

      this.sortSizes();

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-opt]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        this.touched = true;
        if (btn.dataset.opt === 'color') {
          this.color = btn.dataset.value;
          this.swapImage();
        } else {
          this.size = this.size === btn.dataset.value ? null : btn.dataset.value;
          if (this.size && this.ci > -1 && !this.find(this.color, this.size, true)) {
            const alt = this.find(null, this.size, true);
            if (alt) {
              this.color = alt.o[this.ci];
              this.swapImage();
            }
          }
        }
        this.render();
      });

      this.render();
    }

    sortSizes() {
      const wrap = this.querySelector('.bsw-card__sizes');
      if (!wrap) return;
      const btns = Array.prototype.slice.call(wrap.querySelectorAll('button[data-opt="size"]'));
      btns
        .map((b, i) => ({ b: b, i: i }))
        .sort((x, y) => compareSizes(x.b.dataset.value, y.b.dataset.value) || x.i - y.i)
        .forEach((x) => wrap.appendChild(x.b));
    }

    find(color, size, onlyAvailable) {
      return this.variants.find((v) =>
        (this.ci < 0 || color === null || v.o[this.ci] === color) &&
        (this.si < 0 || size === null || v.o[this.si] === size) &&
        (!onlyAvailable || v.a)
      );
    }

    swapImage() {
      if (!this.img || this.ci < 0) return;
      const withImg = this.variants.find((v) => v.o[this.ci] === this.color && v.img);
      if (withImg) {
        this.img.removeAttribute('srcset');
        this.img.setAttribute('src', withImg.img);
      } else if (this.imgOrig) {
        this.img.setAttribute('src', this.imgOrig.src);
        if (this.imgOrig.srcset) this.img.setAttribute('srcset', this.imgOrig.srcset);
      }
    }

    render() {
      this.querySelectorAll('button[data-opt="size"]').forEach((b) => {
        const val = b.dataset.value;
        const available = !!this.find(null, val, true);
        b.disabled = !available;
        if (!available && this.size === val) this.size = null;
        const on = this.size === val;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      this.querySelectorAll('button[data-opt="color"]').forEach((b) => {
        const val = b.dataset.value;
        const on = val === this.color;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        const ok = !this.size || !!this.find(val, this.size, true);
        b.classList.toggle('is-unavailable', !ok);
        b.title = val + (this.size && !ok ? ' – in Größe ' + this.size + ' nicht verfügbar' : '');
      });
      if (this.colorLabel && this.color) this.colorLabel.textContent = this.color;

      if (!this.cta || !this.baseHref) return;

      const parts = [];
      if (this.size) parts.push(this.size);
      if (this.touched && this.color && this.ci > -1) parts.push(this.color);
      if (this.ctaSel) this.ctaSel.textContent = parts.length ? '· ' + parts.join(' · ') : '';

      const url = new URL(this.baseHref, window.location.origin);
      if (this.touched) {
        const v = this.find(this.color, this.size, true) || this.find(this.color, this.size, false);
        if (v) url.searchParams.set('variant', v.id);
      }
      this.cta.setAttribute('href', url.pathname + url.search);
    }
  }

  customElements.define('bsw-card-picker', BswCardPicker);
})();
